import { createTheme, PaletteColorOptions, Theme } from "@mui/material";
const { palette } = createTheme();
const { augmentColor } = palette;

const createColor = (mainColor: string) =>
  augmentColor({ color: { main: mainColor } });

declare module "@mui/material/styles" {
  interface CustomPalette {
    green: PaletteColorOptions | any;
    blue: PaletteColorOptions | any;
    pink: PaletteColorOptions | any;
    red: PaletteColorOptions | any;
    black: PaletteColorOptions | any;
    cGrey: PaletteColorOptions | any;
    lightBlue: PaletteColorOptions | any;
  }

  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    green: true;
    red: true;
    lightBlue: true;
    pink: true;
    blue: true;
  }
}

declare module "@mui/material/CircularProgress" {
  interface CircularProgressPropsColorOverrides {
    blue: true;
  }
}

const theme: Theme = createTheme({
  palette: {
    primary: createColor("#056839"),
    green: createColor("#65C385"),
    blue: createColor("#0892F5"),
    pink: createColor("#EB698F"),
    red: createColor("#F30707"),
    black: createColor("#2B2B2B"),
    cGrey: createColor("#717171"),
    lightBlue: createColor("#D9E2EB"),
  },
  typography: {
    fontFamily: ['"Noto Sans Thai"', "sans-serif"].join(","),
    h1: {
      fontSize: 48,
      fontWeight: 600,
    },
    h2: {
      fontSize: 36,
      fontWeight: 600,
    },
    h3: {
      fontSize: 28,
      fontWeight: 600,
    },
    h4: {
      fontSize: 24,
      fontWeight: 600,
    },
    h5: {
      fontSize: 20,
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: 20,
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: 18,
      fontWeight: 400,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  // components: {
  //   MuiButton: {
  //     styleOverrides: {
  //       root: {
  //         height: "50px",
  //       },
  //     },
  //   },
  //   MuiInputBase: {
  //     styleOverrides: {
  //       root: {
  //         height: "50px",
  //       },
  //     },
  //   },
  // },
});

export { theme };
